export const formatSortCode = (sortCode) => {
  if (!sortCode) {
    return '';
  }
  // Ensure it's a string, remove existing hyphens, and then add hyphens every 2 digits.
  return sortCode.toString().replace(/-/g, '').replace(/(.{2})(.{2})(.{2})/, '$1-$2-$3');
};